import {
    Injectable,
    EventEmitter,
    Injector
} from '@angular/core';
import {
    Http,
    RequestOptions,
    RequestMethod,
    Headers
} from '@angular/http';
//import { Observable } from 'rxjs/Observable';
import {
    Configuration
} from '../configurations/shared.config';
import {
    RoutingAuthenticationService
} from './routing-authentication';
import {
    DiagnosedItem
} from '../dataModels/diagnosed-item';
import {
    log
} from 'util';
import {
    BehaviorSubject,
    Observable
} from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';
//import 'rxjs/add/operator/map'

@Injectable()
export class AuthenticationService extends DiagnosedItem {
    constructor(
        private http: Http,
        protected __inj: Injector ) {
        super( __inj );
    }

    private tokenUrl: string = Configuration.urls.webApiEndpoint + Configuration.urls.tokenUrl;
    private logoutUrl: string = Configuration.urls.webApiEndpoint + Configuration.urls.logoutUrl;
    private validateTokenUrl: string = Configuration.urls.webApiEndpoint + Configuration.urls.validateTokenUrl;

    isLogged: boolean = false;
    firstName: string = "";
    staffId: string;
    subId: string;
    verticalEditionPairs: any[];
    staffData: BehaviorSubject < any > = new BehaviorSubject < any > ( null );
    private grant_type: string = 'password';
    redirectUrl: string;

    public loggedIn: EventEmitter < any > = new EventEmitter < any > ();
    public loggedOut: EventEmitter < any > = new EventEmitter < any > ();

    login(username, password) {
        var loginData = {
            grant_type: 'password',
            username: username,
            password: password
        };
        localStorage.setItem('loginData', JSON.stringify(loginData));
        var data = this.serializeObj(loginData);
        const jwtTokenRequest = new Promise((resolve, reject) => {
            this.http.post(Configuration.urls.jwtTokenEndPoint + Configuration.urls.tokenUrl, data, this.tokenRequest()).map(r => r.json())
                .subscribe((response) => {
                    if (response && response.access_token) {
                //        this.setJwtToken(response);
                        resolve(response);


                    }
                }, error => {

                    reject(error);
                })
        });
        const normalTokenRequest = new Promise((resolve, reject) => {
            this.http.post(this.tokenUrl, data, this.tokenRequest()).map(r => r.json())
                .subscribe((response) => {
                //    // console.log("login", "response", response);

                //    // login successful if there's a token in the response
                    if (response && response.access_token) {
                //        // store user details and  token in local storage to keep user logged in between page refreshes
                //        this.setCurrentUser(response);
                        resolve(response);
                //        this.loadStaffData();
                //        // this.loggedIn.emit( true );

                    }
                }, error => {
                //    //localStorage.removeItem('currentUser');
                    reject(error);
                })
        });
        let resFork = forkJoin([normalTokenRequest,jwtTokenRequest]);
        resFork.subscribe(([res1, res2]) => {
            if (res1 && (res1 as any).access_token && res2 && (res2 as any).access_token) {
                this.setCurrentUser(res1);
                this.loadStaffData();
                this.setJwtToken(res2);
            }
        });
        return resFork;
    }

    logout() {
        this.redirectUrl = '/';
        // remove user from local storage to log user out

        if ( this.isLogged ) {
            this.isLogged = false;
            if (localStorage.getItem('loginData')) {
                localStorage.removeItem("loginData");
            }

            return new Promise( ( resolve, reject ) => {
                this.http.post( this.logoutUrl, '' ).subscribe( response => {

                    this.removeUser();
                    resolve( response );
                    this.loggedOut.emit( true );

                }, error => {

                    this.removeUser();
                    reject( error );
                    this.loggedOut.emit( true );

                } )
            });
            
      
        } else {
            return new Promise( ( resolve, reject ) => {
                resolve( true );
            } );
        }


    }

    removeUser() {
        this.isLogged = false;
        localStorage.removeItem( 'FMSCurrentUser' );
        localStorage.removeItem( 'StaffData' );
        localStorage.removeItem( 'JwtToken' );
        localStorage.removeItem( 'permission' );
    }

    validateToken() {
        return this.http.post( this.validateTokenUrl, '' );
    }

    setCurrentUser( user: any ) {
        this.isLogged = true;
        this.firstName = user.firstName;
        //this.profilePictureId = user.profilePictureId;
        localStorage.setItem( 'FMSCurrentUser', JSON.stringify( user ) );
        // console.log( "setCurrentUser", user )
    }
    setJwtToken(user:any) {
        localStorage.setItem('JwtToken', JSON.stringify({ access_token: user.access_token }));
    
    }
    getCurrentUser() {
        if ( localStorage.getItem( 'FMSCurrentUser' ) ) {
            try {
                let currentUser = JSON.parse( localStorage.getItem( 'FMSCurrentUser' ) );
                if ( currentUser && currentUser.access_token )
                    return currentUser;
            } catch ( err ) {
                return null;
            }


        }
        return null;
    }

    validUser() {
        let currentUser = this.getCurrentUser();
        if ( currentUser && currentUser.access_token ) {

            this.firstName = currentUser.firstName;
            this.staffId = currentUser.staffId;
            this.subId = currentUser.subId;
            this.verticalEditionPairs = JSON.parse( currentUser.verticalEdition || "{}" );
            //this.profilePictureId = currentUser.profilePictureId;
            this.isLogged = true;
            //this.firstName = currentUser.firstName;
            return true;
        }

        this.isLogged = false;
        return false;
    }


    private serializeObj( obj ) {
        var result = [];
        for ( var property in obj )
            result.push( encodeURIComponent( property ) + "=" + encodeURIComponent( obj[ property ] ) );

        return result.join( "&" );
    }

    private tokenRequest() {
        let header = new Headers( {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        } );
        let options = new RequestOptions( {
            method: RequestMethod.Post,
            headers: header
        } );

        return options;
    }


    setStaffData( StaffData ) {
        // console.log( "setStaffData", StaffData )
        localStorage.setItem( 'StaffData', JSON.stringify( StaffData ) );
    }
    getStaffData() {
        // console.log( "getStaffData" );
        if ( localStorage.getItem( 'StaffData' ) ) {
            let StaffData = JSON.parse( localStorage.getItem( 'StaffData' ) );
            this.staffData.next( StaffData );
        } else {
            // console.log( "in else" );
            this.loadStaffData();
        }
    }

    //load Subscriber Configuration
    loadStaffData() {
        // console.log( "loadStaffData" );
        let currentUser = this.getCurrentUser();
        if ( currentUser && currentUser.access_token ) {
            // console.log("inside if :currentUser && currentUser.access_token");
            
            this.http.get( Configuration.urls.webApiEndpoint + Configuration.urls.staffApi ).map( res => res.json() ).subscribe( response => {
                // console.log("loadStaffData response", response);
                
                if ( !response.IsErrorState ) {
                    this.setStaffData( response.Value );
                    this.staffData.next( response.Value );
                    
                }
            } )
        }
    }



    checkIsLogged(): boolean {
        if ( localStorage.getItem( 'FMSCurrentUser' ) ) {
            var tokenData = JSON.parse( localStorage.getItem( 'FMSCurrentUser' ) );
            return tokenData && tokenData.access_token;
        } else
            return false;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/authentication.service.ts